// v3/design-system/primitives/textarea.tsx — Textarea primitive
// Shadcn/UI pattern: forwardRef, cn() merging, 44px min touch target.
// Zero imports from v1/v2.

import * as React from 'react';

import { cn } from '../utils';
import { commitTrimmed } from './input';

type TextareaProps = React.ComponentProps<'textarea'> & {
  /** Opt out of trim-on-blur (default: trims leading/trailing whitespace). */
  noTrim?: boolean;
};

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, noTrim, onBlur, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          'flex min-h-[80px] w-full rounded-md border border-input bg-background px-4 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          props['aria-invalid'] && 'border-red-500 focus-visible:ring-red-500',
          className,
        )}
        ref={ref}
        onBlur={(e) => {
          if (!noTrim) commitTrimmed(e.currentTarget);
          onBlur?.(e);
        }}
        {...props}
      />
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
